import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const HowItWorks = ({ onGetStarted }) => {
  const steps = [
    {
      number: '01',
      title: 'Share Your Requirement',
      description: 'Pick a service and share a quick brief about your investment goals.',
      tag: '5 min to start',
    },
    {
      number: '02',
      title: 'Talk to Our Expert',
      description: 'A focused consultation — zero distractions, zero product pitches. Pure advisory.',
      tag: '30 min call',
    },
    {
      number: '03',
      title: 'Get Your Plan of Action',
      description: 'Receive a personalized investment strategy with next steps and expert recommendations.',
      tag: 'Instant',
    },
  ];

  return (
    <section className="how-it-works-section" data-testid="how-it-works">
      <div className="how-container">
        <p className="how-label">HOW IT WORKS</p>
        <h2 className="how-title">
          Your journey to <span className="how-highlight">financial clarity</span>
        </h2>
        <p className="how-subtitle">
          Get an actionable and personalized plan based on your investment goals
        </p>
        <Button className="btn-primary how-cta" data-testid="how-get-started-btn" onClick={onGetStarted}>
          Get started now <ArrowRight size={20} />
        </Button>

        <div className="how-steps">
          {steps.map((step, idx) => (
            <div key={idx} className="how-step" data-testid={`how-step-${idx}`}>
              <div className="how-step-number">{step.number}</div>
              <h3 className="how-step-title">{step.title}</h3>
              <p className="how-step-desc">{step.description}</p>
              <span className="how-step-tag">{step.tag}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
